import { render, staticRenderFns } from "./tab-default.vue?vue&type=template&id=15fad41a"
import script from "./tab-default.vue?vue&type=script&lang=ts"
export * from "./tab-default.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports